<template>
    <b-form-group
      label="Fenomen Seçimi"
      label-for="inf_id"
    >
    <v-select
      id="inf_id"
      :options="extendedFenomenList"
      v-model="localSelected"
      :reduce="val => val.value"
      class="w-100"
      placeholder="Fenomen seçin (birden fazla seçilebilir)"
      :clearable="false"
      :style="editingLink ? 'pointer-events: none; opacity: 0.6' : ''"
      multiple
      @input="handleInput"
    />
      <small class="text-muted">
        Birden fazla fenomen seçebilirsiniz. Her fenomen için ayrı bir paylaşım linki oluşturulacaktır.
      </small>
    </b-form-group>
  </template>
  <script>
  import { BFormGroup } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import { computed, ref, watch } from '@vue/composition-api'
  
  export default {
    name: 'FenomenSelection',
    components: {
      BFormGroup,
      vSelect
    },
    props: {
      fenomenList: {
        type: Array,
        required: true
      },
      selectedInfIds: {
        type: Array,
        required: true
      },
      editingLink: {
        type: Object,
        default: null
      }
    },
    emits: ['update-selected'],
    setup(props, { emit }) {
      const localSelected = ref([...props.selectedInfIds]) // ✅ lokal kopya
  
      // Prop güncellenirse local kopyayı da senkronize et
      watch(() => props.selectedInfIds, (newVal) => {
        localSelected.value = [...newVal]
      })
  
      const extendedFenomenList = computed(() => [
        {
          label: localSelected.value.length === props.fenomenList.length
            ? 'Tümünü Kaldır'
            : 'Tümünü Seç',
          value: 'all'
        },
        ...props.fenomenList
      ])
  
      const handleInput = (val) => {
        // Eğer "Tümünü Seç/Kaldır" seçildiyse özel işlem
        if (val.includes('all')) {
          if (localSelected.value.length === props.fenomenList.length+1) {
            localSelected.value = []
          } else {
            localSelected.value = props.fenomenList.map(item => item.value)
          }
        } else {
          localSelected.value = val
        }
        emit('update-selected', localSelected.value)
      }
  
      return {
        localSelected,
        extendedFenomenList,
        handleInput
      }
    }
  }
  </script>
  
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>